import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { NAV_LINKS, STUDIO } from '@/constants/site'

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='ed'>
            <div className='ed-wrap'>
                <div className='ed-footer flex flex-wrap items-center justify-between gap-x-10 gap-y-5'>
                    <span>
                        Morph Photographic · London
                    </span>

                    <nav className='flex flex-wrap items-center gap-x-8 gap-y-3' aria-label='Footer'>
                        {NAV_LINKS.map((link) => (
                            <Link key={link.href} href={link.href}>
                                {link.label}
                            </Link>
                        ))}

                        {STUDIO.socials.map((social) => (
                            <a
                                key={social.href}
                                href={social.href}
                                target='_blank'
                                rel='noreferrer noopener'
                            >
                                {social.label}
                            </a>
                        ))}
                    </nav>

                    <span>
                        © 2026 — All rights reserved
                    </span>
                </div>
            </div>
        </footer>
    )
}
